import React from 'react';
import langConf from "../js/lang";
import BackButton from './BackButton';

class TransactionResult extends React.Component {
    render() {
        let lang = this.props.lang;
        let result = this.props.transactionResult === 'success' ? langConf[lang].transactionSucceeded : langConf[lang].transactionFailed;
        return (
            <div className="col-12">
                <div className="col-12">
                    <div className="col-5 col-xs-3"></div>
                    <div className="col-2 col-xs-6">
                        <img src={`${this.props.vendorData.logoUrlHeb}`} alt="logo"></img>
                    </div>
                    <div className="col-5 col-xs-3"></div>
                </div>
                <h1>{result}</h1>
                <h3>{this.props.transactionResult === 'success' ? langConf[lang].invoiceInEmail : ''}</h3>
                <div className="col-3"></div>
                <div className="col-6">
                    <BackButton
                        //Globals
                        lang={this.props.lang}
                        currentURL={this.props.currentURL}
                        //Methods
                        onClick={(event) => { event.preventDefault(); this.props.changeScreen('items') }}
                    />
                </div>
                <div className="col-3"></div>
            </div>
        );
    };
}

export default TransactionResult;